import { createAction, props } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { AddCartItemParam, CartItem } from '../types/cart-item.type';
import { Cart, CartPromocodePostParams } from '../types/cart.type';

export enum CartItemActionTypes {
  REMOVE_CART_ITEM = '[CartItem] Remove CartItem',
  REMOVE_CART_ITEM_SUCCESS = '[CartItem] Remove CartItem Success',
  REMOVE_CART_ITEM_FAIL = '[CartItem] Remove CartItem Fail',

  UPDATE_CART_ITEM_QUANTITY = '[CartItem] Update CartItem Quantity',
  UPDATE_CART_ITEM_QUANTITY_SUCCESS = '[CartItem] Update CartItem Quantity Success',
  UPDATE_CART_ITEM_QUANTITY_FAIL = '[CartItem] UpdateCartItem Quantity Fail',

  ADD_CART_ITEM = '[CartItem] Add CartItem ',
  ADD_CART_ITEM_SUCCESS = '[CartItem] Add CartItem Success',
  ADD_CART_ITEM_FAIL = '[CartItem] Add CartItem Fail',

  LOAD_CART = '[Cart] Load Cart',
  LOAD_CART_AFTER_ADDING_ITEM = '[Cart] Load Cart After Adding Item',
  LOAD_CART_SUCCESS = '[Cart] Load Cart Success',
  LOAD_CART_FAIL = '[Cart] Load Cart Fail',

  ADD_CART_PROMOCODE = '[Cart] Add Cart Promocode',
  ADD_CART_PROMOCODE_SUCCESS = '[Cart] Add Cart Promocode Success',
  ADD_CART_PROMOCODE_FAIL = '[Cart] Add Cart Promocode Fail',

  REMOVE_CART_PROMOCODE = '[Cart] Remove Cart Promocode',
  REMOVE_CART_PROMOCODE_SUCCESS = '[Cart] Remove Cart Promocode Success',

  REMOVE_CART_EXPIRED_PROMOCODE = '[Cart] Remove Cart Expired Promocode',

  REMOVE_CART_PROMOCODE_FAIL = '[Cart] Remove Cart Promocode Fail',

  RESET_CART_PROMOCODE_ERROR = '[Cart] Reset Cart Promocode Error',
}

export const RemoveCartItems = createAction(
  CartItemActionTypes.REMOVE_CART_ITEM,
  props<{ id: CartItem['id'] }>(),
);

export const RemoveCartItemsSuccess = createAction(
  CartItemActionTypes.REMOVE_CART_ITEM_SUCCESS,
);

export const RemoveCartItemsFail = createAction(
  CartItemActionTypes.REMOVE_CART_ITEM_FAIL,
  props<HttpError>(),
);

export const UpdateCartItemQuantity = createAction(
  CartItemActionTypes.UPDATE_CART_ITEM_QUANTITY,
  props<{ id: CartItem['id']; quantity: number }>(),
);

export const UpdateCartItemQuantitySuccess = createAction(
  CartItemActionTypes.UPDATE_CART_ITEM_QUANTITY_SUCCESS,
);

export const UpdateCartItemQuantityFail = createAction(
  CartItemActionTypes.UPDATE_CART_ITEM_QUANTITY_FAIL,
  props<HttpError>(),
);

export const AddCartItem = createAction(
  CartItemActionTypes.ADD_CART_ITEM,
  props<AddCartItemParam>(),
);

export const AddCartItemSuccess = createAction(
  CartItemActionTypes.ADD_CART_ITEM_SUCCESS,
  props<{ productName: string; quantity: number }>(),
);

export const AddCartItemFail = createAction(
  CartItemActionTypes.ADD_CART_ITEM_FAIL,
  props<Record<string, string | number | HttpError> & { error: HttpError }>(),
);

// Cart api related actions

export const LoadCart = createAction(CartItemActionTypes.LOAD_CART);

export const LoadCartAfterAddingItem = createAction(
  CartItemActionTypes.LOAD_CART_AFTER_ADDING_ITEM,
  props<{
    addToCartPromptDialogData: {
      dialogTitle: string;
      productName: string;
      quantity: number;
    };
  }>(),
);

export const LoadCartSuccess = createAction(
  CartItemActionTypes.LOAD_CART_SUCCESS,
  props<{ cart: Cart }>(),
);

export const LoadCartFail = createAction(
  CartItemActionTypes.LOAD_CART_FAIL,
  props<HttpError>(),
);

export const AddCartPromocode = createAction(
  CartItemActionTypes.ADD_CART_PROMOCODE,
  props<CartPromocodePostParams>(),
);

export const AddCartPromocodeSuccess = createAction(
  CartItemActionTypes.ADD_CART_PROMOCODE_SUCCESS,
  props<{ cart: Cart }>(),
);

export const AddCartPromocodeFail = createAction(
  CartItemActionTypes.ADD_CART_PROMOCODE_FAIL,
  props<HttpError>(),
);

export const RemoveCartPromocode = createAction(
  CartItemActionTypes.REMOVE_CART_PROMOCODE,
);

export const RemoveCartPromocodeSuccess = createAction(
  CartItemActionTypes.REMOVE_CART_PROMOCODE_SUCCESS,
);

export const RemoveCartExpiredPromocode = createAction(
  CartItemActionTypes.REMOVE_CART_EXPIRED_PROMOCODE,
);

export const RemoveCartPromocodeFail = createAction(
  CartItemActionTypes.REMOVE_CART_PROMOCODE_FAIL,
  props<HttpError>(),
);

export const ResetCartPromocodeError = createAction(
  CartItemActionTypes.RESET_CART_PROMOCODE_ERROR,
);
